module.exports = __webpack_public_path__ + "media/images/empty-list-customers-ce22f639c5f12323033349189e9c4058.png";